import AgreementUser from "@/views/agreement/agreement-user";
import AgreementPolicy from "@/views/agreement/agreement-policy";
export default {
  name: "",
  components: {
    AgreementUser,
    AgreementPolicy
  },
  data() {
    return {
      modal: {
        title: $t("evvd2", "同步"),
        visible: false
      },
      config: {
        agreementType: ""
      }
    };
  },
  methods: {
    close() {
      this.modal.visible = false;
    },
    open(type) {
      this.modal.title = type === "user" ? $t("f6rg5q4", "用户协议") : $t("jhz6y04", "隐私政策");
      this.config.agreementType = type;
      this.modal.visible = true;
    }
  }
};